// Classes.
import { BooleanLocatorComponent } from "./boolean.locator-component";

export class ParaArcheryLocatorComponent extends BooleanLocatorComponent {
  public toString(): string {
    return this._value != undefined ? `ParaNew-${this._value.toString()}` : "noParaNew";
  }
  public constructor(protected _value: boolean = false) {
    super();
  }

  /**
   * value setter/getter.
   */
  set value(value: boolean) {
    this._value = value;
  }

  get value(): boolean {
    return this._value;
  }
}
